import { useState, useEffect } from 'react';
import { Header } from "../components/Header.jsx";
import { Box, Typography, Tabs, Tab, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { userData } from '../services/userData.js';
import { saveUserData } from '../services/saveUserData.js';
import { changePass } from '../services/changePass.js';
import useUserStore from '../store/UserStore.js';
import { STPButton } from '../components/Botones.jsx';
import { PersonalFields } from './subpages/PersonalFields_DadesGenerals.jsx';
import { ContactFields } from './subpages/ContactFields_DadesGenerals.jsx';
import { UserFields } from './subpages/UserFields_DadesGenerals.jsx';
import { BancariesFields } from './subpages/BancariesFields_DadesGenerals.jsx';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import Person1 from '../assets/icons/1.png';
import Person2 from '../assets/icons/2.png';
import Contact1 from '../assets/icons/3.png';
import Contact2 from '../assets/icons/4.png';
import Account1 from '../assets/icons/5.png';
import Account2 from '../assets/icons/6.png';
import Banking1 from '../assets/icons/7.png';
import Banking2 from '../assets/icons/8.png';
import { all } from 'axios';

const StyledTab = styled(Tab)({
  color: '#50A579',
  borderRadius: '20px',
  maxHeight: '50px',
  maxWidth: '50px',
  '&.Mui-selected': {
    color: 'black',
    backgroundColor: '#9dd49e',
  },
  '&.css-1aquho2-MuiTabs-indicator': {
    backgroundColor: 'black',
  },
});

export function DadesGenerals({ setIsAuthenticated }) {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);
  const [formData, setFormData] = useState({});
  const [initialData, setInitialData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});
  const user = useUserStore(state => state.user);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [alertOpen, setAlertOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [nextTabValue, setNextTabValue] = useState(null);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const response = await userData();
      const apiData = response.data;

      const initialFormData = {
        nom: apiData.nombre || "",
        cognoms: `${apiData.apellidos || ""}`,
        dni: apiData.dni || "",
        dataNaixement: apiData.fnacimiento ? new Date(apiData.fnacimiento).toISOString().split('T')[0] : null,
        adressa: apiData.direccion || "",
        codiPostal: apiData.cp || "",
        poblacio: apiData.poblacione?.clave || null,
        centre: apiData.idcentro || null,
        formacio: apiData.nivel_formacion || null,
        correuElectronic: apiData.email || "",
        telefon1: apiData.tel1 || "",
        telefon2: apiData.tel2 || "",
        identificadorUsuari: user.idpersona,
        correuElectronicUsuari: user.email,
        nomTitular: apiData.nom_ban || "",
        nifTitular: apiData.nif_ban || "",
        adressaTitular: apiData.dir_ban || "",
        codiPostalTitular: apiData.cp_ban || "",
        poblacioTitular: apiData.pob_ban || null,
        pagament_efectiu: apiData.pago_efectivo || null,
        iban: apiData.iban || null,
        professio: apiData.profesion || null,
        contrasenya: '',
        repetirContrasenya: ''
      };

      setFormData(initialFormData);
      setInitialData(initialFormData);
      setUnsavedChanges(false);
    } catch (error) {
      setError(t('generalData.fetchError'));
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    //if (JSON.stringify(formData) !== JSON.stringify(initialData)) {
    //  setNextTabValue(newValue);
    //  setConfirmDialogOpen(true);
    //} else {
      setTabValue(newValue);
      setUnsavedChanges(false);
    //}
  };

  {/*

  const handleConfirmLeave = () => {
    setConfirmDialogOpen(false);
    setTabValue(nextTabValue);
    setUnsavedChanges(false);
  };

  const handleCancelLeave = () => {
    setConfirmDialogOpen(false);
  };^
  */}

  useEffect(() => {}, [fieldErrors]);

  const validateField = (field, value, allValues) => {
    const requiredFields = (parseInt(allValues.pagament_efectiu) === 1) ? ['nom', 'cognoms', 'dni', 'dataNaixement', 'adressa', 'codiPostal', 'telefon1'] : ['nom', 'cognoms', 'dni', 'dataNaixement', 'adressa', 'codiPostal', 'telefon1', 'nomTitular', 'nifTitular', 'adressaTitular', 'codiPostalTitular', 'iban'];
    let error = null;

    if (requiredFields.includes(field) && !value) {
      error = ['nomTitular', 'nifTitular', 'adressaTitular', 'codiPostalTitular', 'iban'].includes(field) ? t('fields.required') + t('fields.requiredBanking') : t('fields.required');
    }

    switch (field) {
      case 'correuElectronicUsuari':
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value && !emailRegex.test(value)) {
          error = t('fields.emailInvalid');
        }
        break;
      case 'contrasenya':
      case 'repetirContrasenya':
        if (allValues.contrasenya) {
          if (allValues.contrasenya !== allValues.repetirContrasenya) {
            error = t('fields.passwordMismatch');
          }
          else if (allValues.contrasenya.length < 8 || allValues.contrasenya.length > 15) {
            error = t('fields.passwordLength');
          }
          else if (!allValues.contrasenya.match(/[a-z]/) || !allValues.contrasenya.match(/[A-Z]/) || !allValues.contrasenya.match(/[0-9]/)) {
            error = t('fields.passwordComplexity');
          }
        }
        break;
      case 'iban':
        if (value !== "ES" && value) {
          if (!validarIBAN(value)) {
            error = t('bankingFields.invalidIban');
          }
        }
        break;
    }

    return error;
  };

  const validarIBAN = (iban) => {
    // Eliminar espacios y convertir a mayúsculas
    const ibanSinEspacios = iban.replace(/\s+/g, '').toUpperCase();

    // El IBAN debe tener al menos 15 caracteres y un máximo de 34
    if (ibanSinEspacios.length < 15 || ibanSinEspacios.length > 34) {
      return false;
    }

    // Mover los cuatro primeros caracteres al final
    const rearrangedIban = ibanSinEspacios.slice(4) + ibanSinEspacios.slice(0, 4);

    // Convertir letras en números (A = 10, B = 11, ..., Z = 35)
    const ibanNumerico = rearrangedIban.split('').map(char => {
      const code = char.charCodeAt(0);
      return code >= 65 && code <= 90 ? (code - 55).toString() : char;
    }).join('');

    // Convertir el número a BigInt y calcular el resto de la división por 97
    const mod97 = BigInt(ibanNumerico) % BigInt(97);

    return mod97 === 1n;
  };


  const handleInputChange = (field, value) => {
    const newFormData = {
      ...formData,
      [field]: value
    };
  
    setFormData(newFormData);
  
    const hasChanges = JSON.stringify(newFormData) !== JSON.stringify(initialData);
    setUnsavedChanges(hasChanges);
  
    const error = validateField(field, value, newFormData);
  
    const newFieldErrors = {
      ...fieldErrors,
      [field]: error
    };
  
    // Si el campo es 'contrasenya' o 'repetirContrasenya', validar el campo relacionado
    if (field === 'contrasenya' || field === 'repetirContrasenya') {
      const otherField = field === 'contrasenya' ? 'repetirContrasenya' : 'contrasenya';
      const otherError = validateField(otherField, newFormData[otherField], newFormData);
      newFieldErrors[otherField] = otherError;
    }
  
    setFieldErrors(newFieldErrors);
  };

  const moveToFieldGroup = (field) => {
    console.log("field", field);
    const PersonalFields = ['nom', 'cognoms', 'dni', 'dataNaixement', 'adressa', 'codiPostal', 'poblacio', 'centre', 'formacio'];
    const ContactFields = ['telefon1', 'telefon2'];
    const UserFields = ['contrasenya', 'repetirContrasenya'];
    const BancariesFields = ['nomTitular', 'nifTitular', 'adressaTitular', 'codiPostalTitular', 'poblacioTitular', 'pagament_efectiu', 'iban'];

    if (PersonalFields.includes(field)) {
      setTabValue(0);

    } else if (ContactFields.includes(field)) {
      setTabValue(1);

    } else if (UserFields.includes(field)) {
      setTabValue(2);

    } else if (BancariesFields.includes(field)) {
      setTabValue(3);

    }
  }
  

  const validateForm = () => {
    const errors = {};
    Object.keys(formData).forEach(field => {
      const error = validateField(field, formData[field], formData);
      if (error) {
        errors[field] = error;
        if (error === t('fields.required') || error === (t('fields.required') + t('fields.requiredBanking'))) {
          setAlertOpen(true);
        }
      }
    });

    if (Object.keys(errors).length > 0) {
      moveToFieldGroup(Object.keys(errors)[0]);
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    const hasChanges = JSON.stringify(formData) !== JSON.stringify(initialData);
    if (!hasChanges) {
      console.log("No hi ha canvis");
      console.log("formData", formData);
      console.log("initialData", initialData);
      return; 
    }

    if (!validateForm()) {
      return; 
    }

    setLoading(true);
    setError(null);

    try {
      if (formData.contrasenya) {
        const response = await changePass(null, formData.contrasenya);
        if (response?.data?.message === "Contraseña cambiada correctamente") {
          setSnackbarMessage(t('generalData.passwordChangeSuccess'));
          setSnackbarOpen(true);
        } else {
          setError(t('generalData.passwordChangeError'));
        }
      }
      // Comrpobar si hay cambios a parte de la contraseña

      const isThereAnyOtherChange = JSON.stringify(
        {
        ...formData,
        contrasenya: '',
        repetirContrasenya: ''
        }) !== JSON.stringify(initialData);

      console.log("isThereAnyOtherChange", isThereAnyOtherChange);

      if (isThereAnyOtherChange) {
        const response = await saveUserData(formData);
        if (response?.data.success) {
          setSnackbarMessage(t('generalData.saveSuccess'));
          setSnackbarOpen(true);
          setInitialData(formData);
          setUnsavedChanges(false);
        } else {
          setError(t('generalData.saveError'));
        }
      }
    } catch (err) {
      setError(t('generalData.saveError'));
      console.error('Error en desar les dades:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress sx={{
          color: 'rgba(80, 165, 121, 0.7)',
        }}/>
      </Box>
    );
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100%',
    }}>
      <Header setIsAuthenticated={setIsAuthenticated} />
      <Box sx={{ flexGrow: 1, padding: 3, maxWidth: '100%', margin: 'auto' }}>
        <Typography variant="h4" sx={{ mb: 4, color: 'black', textAlign: 'center' }}>
          {t('generalData.title1')} <span style={{ color: '#50A579' }}>{t('generalData.title2')}</span>
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{ mb: 2 }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <StyledTab
            icon={<Avatar alt="Person1" src={tabValue === 0 ? Person2 : Person1} sx={{ width: 30, height: 30 }} />}
            iconPosition="start"
          />
          <StyledTab
            icon={<Avatar alt="Contact1" src={tabValue === 1 ? Contact2 : Contact1} sx={{ width: 30, height: 30 }} />}
            iconPosition="start"
          />
          <StyledTab
            icon={<Avatar alt="User1" src={tabValue === 2 ? Account2 : Account1} sx={{ width: 30, height: 30 }} />}
            iconPosition="start"
          />
          <StyledTab
            icon={<Avatar alt="Banking1" src={tabValue === 3 ? Banking2 : Banking1} sx={{ width: 30, height: 30 }} />}
            iconPosition="start"
          />
        </Tabs>


        <Box sx={{ minHeight: '400px' }}>
          {tabValue === 0 && (
            <PersonalFields
              formData={formData}
              handleInputChange={handleInputChange}
              fieldErrors={fieldErrors}
            />
          )}
          {tabValue === 1 && (
            <ContactFields
              formData={formData}
              handleInputChange={handleInputChange}
              fieldErrors={fieldErrors}
            />
          )}
          {tabValue === 2 && (
            <UserFields
              formData={formData}
              handleInputChange={handleInputChange}
              fieldErrors={fieldErrors}
            />
          )}
          {tabValue === 3 && (
            <BancariesFields
              formData={formData}
              handleInputChange={handleInputChange}
              fieldErrors={fieldErrors}
            />
          )}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', mt: 6 }}>
          <STPButton variant="contained" onClick={handleSubmit} sx={{ left: '50%', transform: 'translateX(-50%)', mb: 4 }}>
            {t('generalData.save')}
          </STPButton>
        </Box>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
      >
        <Alert onClose={() => setAlertOpen(false)} severity="warning" sx={{ width: '100%' }}>
          {t('generalData.requiredFieldsWarning')}
        </Alert>
      </Snackbar>

      {/*<Dialog
        open={confirmDialogOpen}
        onClose={handleCancelLeave}
      >
        <DialogTitle>{t('generalData.confirmLeaveTitle')}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('generalData.unsavedChangesPrompt')}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', display: 'flex' }}>
          <Button onClick={handleConfirmLeave} color="primary">
            {t('generalData.leave')}
          </Button>
          <Button onClick={handleCancelLeave} color="secondary">
            {t('generalData.stay')}
          </Button>
        </DialogActions>
      </Dialog>
      */}
    </Box>
  );
}
